import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { canRead } from '../../utils/roles';
import { exportPersonnelPdf, buildPersonnelPdf, deliverPersonnelPdf } from './accessListPdf';

// Bajar la lista de personal (con cédula) desde el celular. En escritorio esto
// vive en el menú de cada fila; acá se ofrece la misma acción, con el mismo
// permiso. En iPhone la entrega va en DOS toques: el primero genera el PDF y el
// segundo lo abre/comparte en un gesto fresco (iOS no deja compartir después de
// esperar el fetch). En PC se baja directo como siempre.
export default function PersonnelPdfButton({ entityType, entityId }) {
  const { user } = useAuth();
  const [doc, setDoc] = useState(null);     // { blob, filename } una vez generado
  const [working, setWorking] = useState(false);
  const workingRef = useRef(false);         // guard síncrono del doble toque

  // El PDF cacheado deja de valer si cambia la entidad: obligar a regenerar.
  useEffect(() => { setDoc(null); }, [entityType, entityId]);

  if (!entityId || !canRead(user, 'agenda.personal-pdf')) return null;

  const isTouch = typeof window !== 'undefined' && window.matchMedia?.('(pointer: coarse)')?.matches;

  const onClick = async () => {
    if (workingRef.current) return;
    workingRef.current = true;
    setWorking(true);
    try {
      // Escritorio: un solo clic baja el PDF.
      if (!isTouch) {
        await exportPersonnelPdf({ entityType, entityId });
        return;
      }
      // Celular, segundo toque: entregar el PDF generado (gesto fresco) y
      // limpiarlo, para que el próximo toque regenere con datos frescos y no se
      // comparta una lista vieja si cambió el personal.
      if (doc) {
        await deliverPersonnelPdf(doc);
        setDoc(null);
        return;
      }
      // Celular, primer toque: generar y dejarlo listo para compartir.
      const built = await buildPersonnelPdf({ entityType, entityId });
      if (built) setDoc(built);
    } finally {
      workingRef.current = false;
      setWorking(false);
    }
  };

  const label = working
    ? (doc ? 'Abriendo…' : 'Generando…')
    : (doc ? 'Abrir / Compartir PDF' : 'PDF Personal');

  return (
    <button
      type="button"
      className={`agm-editor-pdf-btn${doc ? ' is-ready' : ''}`}
      onClick={onClick}
      disabled={working}
    >
      {label}
    </button>
  );
}
